"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VENUE_SEARCH_DEMO_MATCH_DISTANCE_METERS = void 0;
exports.normalizeVenueSearchName = normalizeVenueSearchName;
exports.venueSearchNameSimilarity = venueSearchNameSimilarity;
exports.haversineDistanceMeters = haversineDistanceMeters;
exports.VENUE_SEARCH_DEMO_MATCH_DISTANCE_METERS = 75;
function normalizeVenueSearchName(value) {
  return (value !== null && value !== void 0 ? value : '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
}
/** Simple 0–1 similarity for demo conflation (not production-grade). */
function venueSearchNameSimilarity(a, b) {
  const left = normalizeVenueSearchName(a);
  const right = normalizeVenueSearchName(b);
  if (!left || !right) {
    return 0;
  }
  if (left === right) {
    return 1;
  }
  if (left.includes(right) || right.includes(left)) {
    return 0.85;
  }
  const leftTokens = new Set(left.split(' '));
  const rightTokens = new Set(right.split(' '));
  let overlap = 0;
  for (const token of leftTokens) {
    if (rightTokens.has(token)) {
      overlap += 1;
    }
  }
  const union = new Set([...leftTokens, ...rightTokens]).size;
  return union === 0 ? 0 : overlap / union;
}
function haversineDistanceMeters(lat1, lng1, lat2, lng2) {
  const earthRadiusMeters = 6371e3;
  const lat1Rad = lat1 * Math.PI / 180;
  const lat2Rad = lat2 * Math.PI / 180;
  const deltaLat = (lat2 - lat1) * Math.PI / 180;
  const deltaLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(earthRadiusMeters * c);
}
//# sourceMappingURL=venue-search-demo-match.js.map